
export const adultTeeth = [
  // TL
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 18,
    isSurface: true,
    
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 17,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 16,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 15,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 14,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 13,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 12,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 11,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  // TR
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 21,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 22,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 23,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 24,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 25,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 26,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 27,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 28,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  // UL
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 48,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 47,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 46,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 45,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 44,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 43,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 42,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 41,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  // UR
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 31,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 32,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 33,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    squareColor: "white",
    treatment: "",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 34,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 35,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 36,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 37,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 38,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "OC",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
];
export const childTooth = [
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 55,
    isSurface: true,
    surface: [
      {
        sid: "BU",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "PA",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "OC",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 54,
    isSurface: true,
    surface: [
      {
        sid: "BU",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "PA",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "OC",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 53,
    isSurface: true,
    surface: [
      {
        sid: "BU",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "PA",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 52,
    isSurface: false,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 51,
    isSurface: false,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 61,
    isSurface: false,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 62,
    isSurface: false,
    surface: [
      {
        sid: "LA",
        nsid: "a",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LI",
        nsid: "c",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 63,
    isSurface: false,
    surface: [
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 64,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "PA",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "IN",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
      {
        rootNo: 3,
      },
    ],toothNo: 65,
    isSurface: true,
    surface: [
      {
        sid: "LA",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "PA",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "IN",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 85,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "BU",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "OC",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 84,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "BU",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "OC",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white"
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 83,
    isSurface: false,
    surface: [
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 82,
    isSurface: false,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 81,
    isSurface: false,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 71,
    isSurface: false,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 72,
    isSurface: false,
    surface: [
      {
        sid: "LI",
        nsid: "a",
        color: "white",
      },
      {
        sid: "ME",
        nsid: "b",
        color: "white",
      },
      {
        sid: "LA",
        nsid: "c",
        color: "white",
      },
      {
        sid: "DI",
        nsid: "d",
        color: "white",
      },
      {
        sid: "IN",
        nsid: "e",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
    ],toothNo: 73,
    isSurface: false,
    surface: [
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
      {
        sid: "NS",
        color: "white",
      },
    ],
    treatment: "",
    squareColor: "white",
    front: true,
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 74,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "LA",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "IN",
        color: "white",
      },
    ],
    squareColor: "white",
    treatment: "",
  },
  {
    root: [
      {
        rootNo: 1,
      },
      {
        rootNo: 2,
      },
    ],toothNo: 75,
    isSurface: true,
    surface: [
      {
        sid: "LI",
        color: "white",
      },
      {
        sid: "DI",
        color: "white",
      },
      {
        sid: "LA",
        color: "white",
      },
      {
        sid: "ME",
        color: "white",
      },
      {
        sid: "IN",
        color: "white",
      },
    ],
    squareColor: "white",
    treatment: "",
  },
];
const middleIndex = Math.floor(childTooth.length / 2);

export const allTeeth = [
  ...childTooth.slice(0, middleIndex),
  ...adultTeeth,
  ...childTooth.slice(middleIndex)
];